// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_b4f2df04","icon":"rdg_f484cdac"};